import { useCallback, useEffect, useRef } from "react";
import { useModal } from "@components/Modal/ModalProvider";
import { useAnalysisPage } from "@features/analysis/useAnalysisPage";
import Modal from "@components/Modal";

type ReportModalProps = {
  Component: React.ComponentType<{ onClose: () => void }>,
  updateActivatedTool: (tool: any,check: boolean) => void;
};

export function useReportModal({Component,updateActivatedTool}:ReportModalProps) {
  const ref = useRef<string | null>(null);
  const { openModal, closeModal } = useModal();
  // const { switchConfigs, updateActivatedTool } = useAnalysisPage();

  const closeWithFlagOff = useCallback(() => {
    const id = ref.current;
    if (!id) return;
    closeModal(id);
    ref.current = null;
    updateActivatedTool(
      { id: "switchViewReport", groupName: "annotation", isToggleable: true },
      false
    );
  }, [closeModal, updateActivatedTool]);

  const openReportModal = useCallback(() => {
    ref.current = openModal(
      <Modal
        type="page"
        close={closeWithFlagOff}
        description={<Component onClose={closeWithFlagOff} />}
      />,
      false,
      ()=>updateActivatedTool({ id: "switchViewReport", groupName: "annotation", isToggleable: true },false)
    );
  }, [openModal, closeWithFlagOff, Component]);

  // useEffect(() => {
  //   if (!switchConfigs.switchViewReport) {
  //     closeWithFlagOff();
  //   }
  // }, [switchConfigs.switchViewReport, closeWithFlagOff]);

  return openReportModal;
}
